import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import TruckTypeahead from "@/components/spb/TruckTypeahead";
import { formatPlate } from "@/lib/format";

// Section 04 · Truk & Supir — toggle between master-truck picker and manual
// input. Manual mode adds a checkbox to also persist the new truck.
export default function TrukSection({ form, setF, activeTrucks, trucks, onSelectTruck }) {
  return (
    <div className="border border-border p-6 bg-card">
      <div className="overline mb-4">04 · Truk & Supir</div>
      <div className="flex gap-2 mb-4">
        <button
          type="button"
          onClick={() => setF({ truck_mode: "master", no_polisi: "", nama_supir: "", transporter: "" })}
          className={`px-4 py-2 border text-sm font-semibold uppercase tracking-wider ${
            form.truck_mode === "master" ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border"
          }`}
          data-testid="truck-mode-master"
        >
          Dari Master
        </button>
        <button
          type="button"
          onClick={() => setF({ truck_mode: "manual", truck_id: "", no_polisi: "", nama_supir: "", transporter: "" })}
          className={`px-4 py-2 border text-sm font-semibold uppercase tracking-wider ${
            form.truck_mode === "manual" ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border"
          }`}
          data-testid="truck-mode-manual"
        >
          Input Manual
        </button>
      </div>

      {form.truck_mode === "master" ? (
        <div>
          <Label className="overline block mb-2">Pilih Truk *</Label>
          <TruckTypeahead
            trucks={activeTrucks}
            selectedId={form.truck_id}
            onSelect={(id) => id ? onSelectTruck(id) : setF({ truck_id: "", no_polisi: "", nama_supir: "", transporter: "" })}
          />
          {trucks.length === 0 && (
            <p className="mt-2 text-xs text-muted-foreground">Belum ada truk di master. Gunakan <strong>Input Manual</strong> atau tambah di Master Truk.</p>
          )}
          {form.truck_id && (
            <div className="mt-3 p-3 border border-border bg-secondary/30 text-sm font-mono">
              <div>NO. POL: <strong>{form.no_polisi}</strong></div>
              <div>SUPIR: <strong>{form.nama_supir || "-"}</strong></div>
              <div>TRANSPORTER: <strong>{form.transporter || "-"}</strong></div>
            </div>
          )}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="overline block mb-2">No Polisi *</Label>
            <Input
              value={form.no_polisi}
              onChange={(e) => setF({ no_polisi: formatPlate(e.target.value) })}
              placeholder="BK1234AB (dash otomatis)"
              className="rounded-lg h-11 font-mono font-bold"
              data-testid="input-no-polisi-manual"
              required
            />
          </div>
          <div>
            <Label className="overline block mb-2">Nama Supir</Label>
            <Input
              value={form.nama_supir}
              onChange={(e) => setF({ nama_supir: e.target.value })}
              className="rounded-lg h-11"
              data-testid="input-nama-supir"
            />
          </div>
          <div>
            <Label className="overline block mb-2">Transporter</Label>
            <Input
              value={form.transporter}
              onChange={(e) => setF({ transporter: e.target.value })}
              className="rounded-lg h-11"
              data-testid="input-transporter"
            />
          </div>
          <div className="flex items-end">
            <label className="flex items-center gap-2 cursor-pointer text-sm">
              <Checkbox
                checked={form.simpan_ke_master}
                onCheckedChange={(v) => setF({ simpan_ke_master: !!v })}
                className="rounded-lg"
                data-testid="checkbox-simpan-master"
              />
              <span className="font-semibold">Simpan ke master truk</span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
